exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".comments .comments_title[data-v-02cf971a] {\n  font-size: 24px;\n  padding: 20px 0;\n  margin: 0;\n  text-align: left;\n  text-transform: capitalize;\n  font-weight: 400;\n}", ""]);

// exports
